import React from "react";
import { Box, Button, Column, Columns, Input, Table, Title } from "@allxsmith/bestax-bulma";

function WorkSection({workItem, onRemove, removedWorkItems, onAdd}){

    return (
        <Box>
            {removedWorkItems.indexOf(workItem.id) !== -1 &&
                <Columns isMultiline>
                    <Column>
                        <p style={{color: "red"}}>THIS ITEM WILL BE REMOVED WHEN THE JOB IS CREATED</p>
                    </Column>
                </Columns>
            }
            <Columns isMultiline>
                <Column>
                    <label className="label">Description</label>
                    <Input
                        type={"text"}
                        value={workItem.description}
                        disabled={true}
                    />
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <label className="label">Labour Hours</label>
                    <Input
                        type={"text"}
                        value={workItem.labour_hours}
                        disabled={true}
                    />
                </Column>
                <Column>
                    <label className="label">Labour Cost</label>
                    <Input
                        type={"text"}
                        value={workItem.labour_cost}
                        disabled={true}
                    />
                </Column>
                <Column>
                    <label className="label">Customer Labour Charge</label>
                    <Input
                        type={"text"}
                        value={workItem.customer_labour_cost}
                        disabled={true}
                    />
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Table isFullwidth isBordered>
                        <thead>
                            <tr>
                                <th>Part Name</th>
                                <th>Part Supplier</th>
                                <th>Part Number</th>
                                <th>Part Cost</th>
                                <th>Part Customer Charge</th>
                            </tr>
                        </thead>
                        <tbody>
                        {workItem.part_work_lookup.map(part => (
                            <tr>
                                <td>{part.name}</td>
                                <td>{part.supplier ? part.supplier.name : ""}</td>
                                <td>{part.part_number}</td>
                                <td>{part.cost}</td>
                                <td>{part.customer_cost}</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </Column>
            </Columns>
            <Columns isMultiline>
                {removedWorkItems.indexOf(workItem.id) === -1 &&
                    <Column>
                        <Button
                            color="danger"
                            data-testid="remove-work"
                            className="is-pulled-right remove-work"
                            onClick={() => onRemove(workItem)}
                        >
                            Remove Work
                        </Button>
                    </Column>
                }
                {removedWorkItems.indexOf(workItem.id) !== -1 &&
                    <Column>
                        <Button
                            color="success"
                            data-testid="remove-work"
                            className="is-pulled-right remove-work"
                            onClick={() => onAdd(workItem)}
                        >
                            Add Work
                        </Button>
                    </Column>
                }
            </Columns>
        </Box>
    );

}


export default function DefaultWorkItemsSection({workItems, removedWorkItems, addRemovedWorkItem, removeRemovedWorkItem}){
    // addRemovedWorkItem adds a work item to the list of removed ones, that list will then be used on the backend to tell the api which items to ignore
    // removeRemovedWorkItem removes a work item from the list of removed ones


    return (
        <Box>
            <Columns isMultiline>
                <Column>
                    <Title>Default Work Items</Title>
                </Column>
            </Columns> {/*.filter(item => removedWorkItems.indexOf(item.id) === -1)*/}
            {workItems.results.map(workItem => (
                <WorkSection
                    workItem={workItem}
                    onRemove={addRemovedWorkItem}
                    removedWorkItems={removedWorkItems}
                    onAdd={removeRemovedWorkItem}
                />
            ))}
        </Box>
    );

}